(() => {
  const motion = window.WTCTheme.motion;
  window.WTCTheme.register('[data-disclosure]', (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('[data-disclosure-panel]');
    const controller = new AbortController();
    let animation;
    let generation = 0;
    summary.setAttribute('aria-expanded', String(details.open));
    summary.addEventListener('click', async (event) => {
      event.preventDefault();
      const current = ++generation;
      const opening = summary.getAttribute('aria-expanded') !== 'true';
      const from = details.open ? panel.getBoundingClientRect().height : 0;
      animation?.cancel();
      details.open = true;
      summary.setAttribute('aria-expanded', String(opening));
      panel.inert = !opening;
      animation = motion.animate(panel, [
        { height: `${from}px`, opacity: opening ? 0 : 1 },
        { height: `${opening ? panel.scrollHeight : 0}px`, opacity: opening ? 1 : 0 },
      ]);
      await motion.finished(animation);
      if (current === generation) details.open = opening;
    }, { signal: controller.signal });
    return () => { generation += 1; animation?.cancel(); controller.abort(); };
  });
})();
